import { DataModeler } from '../features/data-modeler';

export function DataModelerPage() {
  return (
    <div className="h-[calc(100vh-4rem)]">
      <DataModeler />
    </div>
  );
}
